import React, { useState, useEffect } from 'react';

import { useDispatch } from 'react-redux';
import Register from '_components/Register';
import Login from '_components/Login';
import { Footer } from './Footer.jsx'
import { useTranslation } from 'react-i18next';


export function FAQ() {
  const dispatch = useDispatch();
  const [showRegister, setShowRegister] = useState(false)
  const [showLogin, setShowLogin] = useState(false)
  const [t, i18n] = useTranslation();

 
  useEffect(() => {


    const hamburgerButton = document.getElementById('hamburger');
    const mobileMenu = document.getElementById('mobile-menu');

    // Add click event listener to toggle mobile menu visibility
    hamburgerButton.addEventListener('click', () => {
      mobileMenu.classList.toggle('hidden')
    });

    const queryParameters = new URLSearchParams(window.location.search)
    const lang = queryParameters.get('lang')

    i18n.changeLanguage(lang)


  },[]);


  return (

    <div class="bg-gray-100 h-full p-4">



      <section class="mx-auto rounded-2xl p-8 md:text-left max-w-[1750px] pb-12">

        <div class="hidden md:flex justify-between items-center md:flex-row flex-col">
          <div class="flex flex-row">
            <a href="index.html">
              <img class="w-[150px]" src="assets/landingpageimages/logo.png" />
            </a>
          </div>
          <div class="flex flex-row">
            <nav class="md:space-x-6 lg:space-x-32 md:flex text-[#183650] text-xl">
              <a href="/howitworks" class="hover:underline">{t('navigation.howItWorks')}</a>
              <a href="/aboutus" class="hover:underline">{t('navigation.aboutUs')}</a>
              <a href="/faq" class="hover:underline">{t('navigation.faq')}</a>
            </nav>
          </div>
          <div class="flex flex-row">
            <button class="bg-white text-[#183650] px-8 py-2 rounded-full mr-2" onClick={() => setShowLogin(true)}>{t('login')}</button>
            <button class="bg-gray-300 text-[#183650] px-8 py-2 rounded-full" onClick={() => setShowRegister(true)}>{t('register')}</button>
          </div>
        </div>



        <div class="md:hidden flex justify-between items-start">
          <div class="flex flex-row">
            <a href="index.html">
              <img class="w-[150px]" src="assets/landingpageimages/logo.png" />
            </a>
          </div>
          <button id="hamburger" class="text-white">
            <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16M4 18h16">
              </path>
            </svg>
          </button>
        </div>



        <div id="mobile-menu" class="md:hidden hidden absolute top-18 right-0 bg-white shadow-lg rounded-lg p-4 z-10">
          <nav class="space-y-4">
            <a href="/howitworks" class="block hover:underline text-lg">{t('navigation.howItWorks')}</a>
            <a href="/aboutus" class="block hover:underline text-lg">{t('navigation.aboutUs')}</a>
            <a href="/faq" class="block hover:underline text-lg">{t('navigation.faq')}</a>
          </nav>
          <div class="flex flex-col space-y-4 mt-6">
            <button class="bg-white text-[#183650] px-8 py-2 rounded-full border border-gray-300" onClick={() => setShowLogin(true)}>{t('login')}</button>
            <button class="bg-gray-300 text-[#183650] px-8 py-2 rounded-full" onClick={() => setShowRegister(true)}>{t('register')}</button>
          </div>
        </div>
      </section>


      <section class="mx-auto  py-8 md:px-2 max-w-[1750px] mb-8  bg-[#183b59] rounded-2xl h-[85%] relative p-8">
        <div class="flex flex-col justify-center align-center items-center h-[100%] text-white leading-[3] text-center">
          <h1 class="text-xl font-bold mb-4">{t('faq.section1.h1')}</h1>
          <p class="text-white leading-snug">{t('faq.section1.p1')}</p>
          {/* <img src="assets/landingpageimages/shape-5.svg" class="hidden lg:block absolute right-0 top-50" /> */}
        </div>
      </section>


      <section class="mx-auto rounded-2xl md:text-left max-w-[1025px] flex justify-center  mb-16">
        <div class="container max-w-[1025px] flex items-center flex-col" >
          <div class="bg-[#183650] p-4 rounded-2xl w-[80%] z-10">
            <div class="text-center text-white leading-relaxed text-2xl font-bold">
              <h1>{t('faq.section2.main')}</h1>
            </div>
          </div>
          <div class="bg-white px-8 p-16 text-center rounded-2xl mt-[-30px] z-1">
            <h1 class="text-xl font-bold mb-4">{t('faq.section2.question1')}</h1>
            <p>{t('faq.section2.answer1')}
            </p><br /><br />
            <h1 class="text-xl font-bold mb-4">{t('faq.section2.question2')}
            </h1>
            <p>{t('faq.section2.answer2')}
            </p><br /><br />
            <h1 class="text-xl font-bold mb-4">{t('faq.section2.question3')}
            </h1>
            <p>{t('faq.section2.answer3')}
            </p><br /><br />
          </div>
        </div>
      </section>


      <section class="mx-auto rounded-2xl md:text-left max-w-[1025px] flex justify-center  mb-16">
        <div class="container max-w-[1025px] flex items-center flex-col" >
          <div class="bg-[#183650] p-4 rounded-2xl w-[80%] z-10">
            <div class="text-center text-white leading-relaxed text-2xl font-bold">
              <h1>{t('faq.section3.main')}</h1>
            </div>
          </div>
          <div class="bg-white px-8 p-16 text-center rounded-2xl mt-[-30px] z-1">
            <h1 class="text-xl font-bold mb-4">{t('faq.section3.question1')}</h1>
            <p>{t('faq.section3.answer1')}
            </p><br /><br />
            <h1 class="text-xl font-bold mb-4">{t('faq.section3.question2')}
            </h1>
            <p>{t('faq.section3.answer2')}
            </p><br /><br />
            <h1 class="text-xl font-bold mb-4">{t('faq.section3.question3')}
            </h1>
            <p>{t('faq.section3.answer3')}
            </p><br /><br />
          </div>
        </div>
      </section>



      <section class="mx-auto rounded-2xl md:text-left max-w-[1025px] flex justify-center  mb-16">
        <div class="container max-w-[1025px] flex items-center flex-col" >
          <div class="bg-[#183650] p-4 rounded-2xl w-[80%] z-10">
            <div class="text-center text-white leading-relaxed text-2xl font-bold">
              <h1>{t('faq.section4.main')}</h1>
            </div>
          </div>
          <div class="bg-white px-8 p-16 text-center rounded-2xl mt-[-30px] z-1">
            <h1 class="text-xl font-bold mb-4">{t('faq.section4.question1')}</h1>
            <p>{t('faq.section4.answer1')}
            </p><br /><br />
            <h1 class="text-xl font-bold mb-4">{t('faq.section4.question2')}
            </h1>
            <p>{t('faq.section4.answer2')}
            </p><br /><br />
            <h1 class="text-xl font-bold mb-4">{t('faq.section4.question3')}
            </h1>
            <p>{t('faq.section4.answer3')}
            </p><br /><br />
          </div>
        </div>
      </section>

      <section
        class="mx-auto bg-[#a8946b] rounded-2xl p-16 md:text-left max-w-[1750px] pb-12 flex justify-center  2xl:mb-16">
        <div class="text-center text-white leading-loose">
          <h1 class="text-xl font-bold">{t('faq.section5.h1')}<br />
          {t('faq.section5.h1.1')}</h1><br />
          <h2 class="text-xl font-bold">info@freightopt.com</h2>
          {/* <button class="bg-[#183650] text-white px-8 py-2 rounded-full mr-2 md:w-[50%]">{t('faq.section5.cta')}</button> */}
        </div>

      </section>

    <Footer setShowLogin={setShowLogin} setShowRegister={setShowRegister}/>

      <Register show={showRegister} hide={setShowRegister} />
      <Login show={showLogin} hide={setShowLogin} />





    </div>
  );

}


